module.exports = __webpack_public_path__ + "static/media/invite_share.66188331.jpg";